<template>
  <el-drawer title="容器码列表" :visible.sync="drawer" :direction="direction" append-to-body :size="deawerSize"
    @close="closeDrawer">
    <div class="wrap">
      <el-form :model="searchParams">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label-position="left" class="fromItem" label="容器名称">
              <el-input v-model="queryParam.name" placeholder="请输入容器名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col style="margin-left: 15px" :span="10">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
            <el-button type="primary" @click="printAll">批量打印</el-button>
            
          
          </el-col>
        </el-row>
      </el-form>
      <commonTable style="height:700px;overflow-y:auto;" :tableData="tableData" :total="total"
        :currentPage="queryParam.pageNum" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
        <template v-slot:table>
          <!-- 添加一个序号 -->
          <el-table-column width="50" label="序号" align="center">
            <template slot-scope="scope">
              <!-- 计算全局序号 -->
              {{ (queryParam.pageNum - 1) * queryParam.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>          
          <el-table-column prop="name" align="center" label="容器名称" />
          <el-table-column prop="handle" align="center" label="标识码" />
          <el-table-column prop="handle" align="center" label="容器码">
            <template slot-scope="scope">
              <vue-qr :id="`codeImage${scope.row.handle}`" :size="50" :margin="0" :auto-color="true" :dot-scale="1"
                :text="`${codeUrl}?h=${scope.row.handle}`" />
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="数量" >
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,1)">{{scope.row.num||'0'}}</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="weight" align="center" label="重量(t)" v-if="warehouseType == 0">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.weight||'0'}}</el-button>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="sorting" align="center" label="排序" /> -->
          <el-table-column align="center" width="200" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="editCode(scope.row)">编辑</el-button>
              <el-button type="text" style="color: red" @click="delCode(scope.row)">删除</el-button>
              <el-button type="text" @click="printSingle(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </div>
    <el-dialog title="详情" :visible.sync="dialogTableVisible" modal-append-to-body append-to-body>
      <el-table :data="gridData">
        <el-table-column property="orderNo" label="订单号" align="center"></el-table-column>
        <el-table-column property="className" label="产品类别" align="center"></el-table-column>
        <!-- <el-table-column property="partNumber" label="件（图）号" align="center"></el-table-column> -->
        <el-table-column property="modelNo" label="型号" align="center"></el-table-column>
        <el-table-column property="inventCode" label="存货编码" align="center"></el-table-column>
        <el-table-column property="specName" label="规格" align="center"></el-table-column>
        <el-table-column v-if="warehouseType != 0" property="num" label="数量" align="center"></el-table-column>
        <!--        <el-table-column property="className" label="类别" align="center"></el-table-column>-->
        <el-table-column v-if="warehouseType == 0" property="weight" label="重量(t)" align="center"></el-table-column>
        <el-table-column v-if="warehouseType == 0" property="num" label="数量" align="center"></el-table-column>
      </el-table>
    </el-dialog>

    <store-code-edit ref="codeEdit" @getList="getList"></store-code-edit>
    <store-code-print ref="codePrint"></store-code-print>
  </el-drawer>

</template>

<script>
  import VueQr from "vue-qr";
  import { get } from "@/utils/request";
  import commonTable from "@/components/common/commonTable";
  import html2canvas from "html2canvas";
  import { fetchWarehouseDetails } from '@/api/storeStack.js'
  import StoreCodeEdit from "./storeCodeEditDialog.vue";
  import StoreCodePrint from "../../storeCode/component/codePrint.vue";
  import { codeUrl } from '@/utils/constant'
  import { deleteCode } from '@/api/storeCode.js'
  export default {
    components: { VueQr, commonTable, StoreCodeEdit, StoreCodePrint },
    data() {
      return {
        codeUrl: codeUrl,
        drawer: false,
        direction: 'rtl',
        deawerSize: 1000,
        tableData: [],
        warehouseId: '',
        total: 1,
        queryParam: {
          pageSize: 10,
          pageNum: 1,
          type: 2,
          parentId: 0,
          search: '',
          name: '',
          warehouseId: '',
          stackId: ''
        },
        warehouseType: '',
        searchParams: {
          name: ''
        },
        dialogTableVisible: false,
        gridData: [],
        numShow: true
      };
    },
    mounted() {
    },
    methods: {
      handleClose(done) {

      },
      reset() {
        this.queryParam.name = ''
        this.getList()
      },
      openDialog(data) {
        console.log(data);
        
        // this.warehouseType = data.warehouseType
        // this.warehouseId = data.id
        // this.queryParam.warehouseId = this.warehouseId
        this.queryParam.stackId = data.id

        this.getList()
        this.drawer = true
      },
      getList() {
        fetchWarehouseDetails(this.queryParam).then(res => {
          this.tableData = res.data.list.map(row => {
            console.log(row);
            return row;
          });
          console.log("this.tableData", this.tableData);
          this.total = res.data.total;
        });
      },
      handleSizeChange(num) {
        this.queryParam.pageSize = num
        this.queryParam.pageNum = 1
        this.getList();
      },
      handleCurrentChange(num) {
        this.queryParam.pageNum = num
        this.getList();
      },
      downTwo(row) {
        let dom = document.getElementById('codeImage' + row.id);
        html2canvas(dom).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          if (dataURL !== "") {
            let a = document.createElement('a')
            a.download = row.fullName + '.png';
            a.href = dataURL;
            a.click()
          }
        })
      },
      closeDrawer() {
        this.$emit('getList')
      },
      codeDetail(row, type) {
        console.log(type);
        console.log("全部的数据", row);
        console.log("发送的数据", row.classVos);
        this.gridData = row.classVos;
        if (type == 0) {
          console.log("收到的数据", this.gridData);
          // this.gridData = this.gridData.map(item => {
          //             // 获取长宽高
          //             // 密度
          //             let density =item.density;
          //             // 长
          //             let length =item.length;
          //             // 宽度
          //             let width =item.width;
          //             // 厚度
          //             let thickness =item.thickness;
          //             let quantity = item.num; // 假设数量字段为 quantity
          //             const lengthInMeters = length / 1000; // 假设输入为毫米
          //             const widthInMeters = width / 1000;   // 假设输入为毫米
          //             const thicknessInMeters = thickness / 1000; // 假设输入为毫米

          //             const volume = lengthInMeters * widthInMeters * thicknessInMeters;
          //             const singleWeight = volume * density;
          //             let totalWeight = singleWeight * quantity;
          // // totalWeight保留3为小数
          //             totalWeight = totalWeight.toFixed(3);
          //             item.weight = totalWeight;
          //             return item;
          // });


        }
        this.dialogTableVisible = true;
      },
      editCode(row) {
        this.$refs.codeEdit.getAllClass(row.codeType == 0 ? 1 : 0)
        this.$refs.codeEdit.getClassList(row.id)
        this.$refs.codeEdit.init(row)
      },
      printAll() {
        this.$refs.codePrint.init('', '', 'all', this.warehouseId)
      },
      printSingle(row) {
        this.$refs.codePrint.init('', row.id, 'single', '')
      },
      delCode(row) {
        let params = {
          codeId: row.id
        }
        this.$confirm('此操作将永久删除该容器码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCode(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {

        })
      },
    }
  };
</script>
<style scoped>
  .wrap {
    padding: 20px;
  }

  .class_item {
    font-size: 16px;
    text-align: center;
  }
</style>